<template>
    <div class="default-panel proDetails-panel">
        <proHeaders
                class="fixed"
                :path="path"
        ></proHeaders>
        <div class="pd30 bg-sec">
            <div class="pro-img-swiper">
                <mt-swipe :auto="3000" v-if="detailImgs.length > 0">
                    <mt-swipe-item class="pro-slide" v-for="(imgUrl,index) in detailImgs" :key="index">
                        <img :src="imgUrl">
                    </mt-swipe-item>
                </mt-swipe>
                <mt-swipe :auto="3000" v-else>
                    <img src="../../../assets/images/default-pro-big.png">
                </mt-swipe>

            </div>

            <div class="pro-titles" v-cloak>
                <h1>{{goodsBean.name}}</h1>
                <p v-if="goodsBean.type != 2" class="text-red">¥<span v-if="currSkuBean.price">{{currSkuBean.price | filterPrice}}</span></p>
                <p v-else class="text-red">¥<span v-if="goodsBean.discountPrice">{{goodsBean.discountPrice | filterPrice}}</span></p>
            </div>
            <!-- 规格 tlp start -->
            <div class="pro-spec" v-if="goodsBean.type != 2">
                <p class="text-grey">{{skuPropertyName}}</p>
                <div class="spec-list">
                    <span class="item-spec" :class="{'active': activeSpec == index}"
                          v-for="(item,index) in productSkuList" @click="getCurrSku(index)">
                        <span v-for="(itemData,index) in item.skuPropertyValues">
                        {{itemData}}
                       </span>
                    </span>
                </div>
            </div>
            <!-- 规格 tlp end -->
            <!-- 选择数量 tlp end -->
            <div class="counter-operate">
                <span class="text-grey">选择数量</span>
                <span>
                    <span class="icon-reduce" @click="reduce"></span>
                    <span class="text-counter">{{counter}}</span>
                    <span class="icon-plus" @click="plus"></span>
                </span>
            </div>
            <!-- 选择数量 tlp end -->
            <div class="pro-help">
                <span class="item-help" @click="promiseShow=true" >幸福承诺</span><span class="item-help">
                    <router-link to="/deliveryArea">查看配送区域</router-link>
                </span>
            </div>
        </div>
        <div class="pd30 bg-sec">
            <div class="pro-details">
                <h3 class="title">产品详情</h3>
                <div class="pro-details-info" v-html="htmlProdetails">
                </div>
            </div>
        </div>

        <div class="pro-footer" v-if="goodsBean.saleStatus == 2">
            <transition name="fade">
                <p v-if="show" class="up-count">+{{counter}}</p>
            </transition>
            <span class="i-cart" @click="submitLoading && addToCart()" >加入购物车</span>
            <span class="i-buynow" @click="submitLoading && checkOut()">立即购买</span>
        </div>
        <div class="pro-footer" v-if="goodsBean.saleStatus == 1">
            <transition name="fade">
                <p v-if="show" class="up-count">+{{counter}}</p>
            </transition>
            <span class="i-cart i-disabled">已下架</span>
        </div>

        <mt-popup
                v-model="promiseShow"
                position='bottom'
                class="promise-popup"
        >
            <span class="promise-btn" @click="promiseShow=false">我知道了</span>
            <div class="promise-sec">
                <p class="title">幸福承诺</p>
                <p class="promise-line"><span class="i-b">就敢退</span> 实物不对版，退款不退货！</p>
                <p class="promise-line"><span class="i-b">就敢减</span> 约定时间！迟到1分钟减1元！</p>
                <p class="promise-line"><span class="i-b">就敢送</span> 迟到30分钟免费赠送！</p>
            </div>
        </mt-popup>

    </div>
</template>
<script>
    import Vue from 'vue';
    import {Lazyload, Toast, Popup, Swipe, SwipeItem} from '@/js/mint-ui';

    Vue.use(Lazyload);
    Vue.component(Swipe.name, Swipe);
    Vue.component(SwipeItem.name, SwipeItem);
    Vue.component(Popup.name, Popup);

    import proHeaders from '@/components/home/productDetail/proDetailHeader'

    export default {
        data() {
            return {
                submitLoading: true,
                show: false,
                promiseShow: false,
                activeSpec: 0,
                currSkuBean: {},//当前所选规格信息
//                currSkuSize: {},//当前所选规格尺寸信息
                skuPropertyName: '',
                templateData: [],//详情
                counter: 1,//数量
                htmlProdetails: '',//详情富文本
                currSkuSizeLen: 0

            }
        },
        components: {
            proHeaders
        },
        computed: {
            goodsBean() {
                return this.$store.state.proDetails.productBean
            },
            productSkuList() {
                return this.$store.state.proDetails.productSkuDetailList
            },
            productDetail() {
                return this.$store.state.proDetails.productDetail
            },
            detailImgs() {
                let imgArr = [];
                let productDetail = this.$store.state.proDetails.productDetail;
                if (productDetail.detailImage) {
                    productDetail.detailImage.map((item, index) => {
                        if (!!item) imgArr.push(item);

                    })
                }
                return imgArr;
            },
            path() {
                return this.$route.query.url
            }
        },
        watch: {
            currSkuSize: function (val) {
                this.currSkuSizeLen = val.length;

            },
            productSkuList: function () {
                this.currSkuBean = this.productSkuList[0];
                this.skuPropertyName = this.productSkuList[0].skuPropertyName ? this.productSkuList[0].skuPropertyName : [];
//                this.currSkuSize = this.productSkuList[0].goodsSpecVos ? this.productSkuList[0].goodsSpecVos: [];
                this.htmlProdetails = this.productDetail.productDetail;
            }
        },
        mounted() {
            var self = this;
            self.getProInfo();

        },
        methods: {
            getProInfo() {
                var goodsChannelId = this.$route.params['id'];
                if (goodsChannelId === undefined) {
                    goodsChannelId = localStorage.getItem('goodsChannelId-cache')
                } else {
                    localStorage.setItem('goodsChannelId-cache', goodsChannelId)
                }
                var goodsChannelId1 = parseInt(goodsChannelId);
                this.$store.dispatch('getDetails', goodsChannelId1).then(function (res) {
                    console.log(res);
                });
            },
            getCurrSku(index) {
                this.activeSpec = index;
                this.currSkuBean = this.productSkuList[index];
//                this.currSkuSize = this.productSkuList[index].goodsSpecVos ? this.productSkuList[index].goodsSpecVos : [] ;
            },
            reduce() {
                if (this.counter <= 1) {
                    return false;
                } else {
                    this.counter--;
                }
            },
            plus() {
                this.counter++;
            },
            addToCart() {
                // 加入购物车，跳转微商城
                let locationCity = JSON.parse(localStorage.getItem('locationCity'));
                 // 下单结算，跳转微商城
				let cityInterceptList = [
                    "上海市",
                    "衡水市",
                    "抚顺市",
                    "南通市",
                    "海门市",
                    "盐城市",
                    "漳州市",
                    "漳浦县",
                    "南昌市",
                    "武汉市",
                    "郴州市",
                    "永兴县",
                    "佛山市",
                    "惠州市",
                    "昆明市",
                    "安宁市",
                    "广州市",
                    "深圳市",
                    "东莞市",
                    // 重庆下面的区
                    "重庆市",
                    "梁平县",
                    "两江新区",
                    "万州区",
                    "渝中区",
                    "大渡口区",
                    "江北区",
                    "沙坪坝区",
                    "九龙坡区",
                    "南岸区",
                    "北碚区",
                    "大足区",
                    "渝北区",
                    "巴南区",
                    "黔江区",
                    "合川区",
                    "南川区",
                    "璧山区",
                    "铜梁区",
                    "潼南县",
                    "城口县",
                    "丰都县",
                    "武隆县",
                    "忠县",
                    "开县",
                    "云阳县",
                    "奉节县",
                    "巫山县",
                    "巫溪县",
                    "石柱土家族自治县",
                    "秀山土家族苗族自治县",
                    "酉阳土家族苗族自治县",
                    "彭水苗族土家族自治县",
                    "开州区",
                    "垫江县",
                    "荣昌县",
                    "綦江区",
                    "涪陵区",
                    "永川区",
                    // 成都眉山地区20210113拦截
                    "眉山市",
                    "成都市",
                    "新津县",
                    // 20110118拦截
                    "温州市",
                    "合肥市",
                    "蚌埠市",
                    "芜湖市",
                    "无锡市",
                    "淮安市",
                    "泰安市",
                    "新泰市",
                    "济南市",
                    "南京市",
                    "中山市",
                    "揭阳市",
                    "揭西县",
                    "厦门市",
                    "柳州市",
                    "北海市",
                    "海口市",
                    "三亚市",
                    "东方市",
                    "东方市, 直辖县级",
                    "吉安市",
                    "萍乡市",
                    "抚州市",
                    "铜仁市",
                    "黔西南布依族苗族自治州",
                    "毕节市",
                    "兰州市",
                    "哈尔滨市",
                    "大连市",
                    "长春市",
                    "张家口市",
                    "滨海新区",
                    "秦皇岛市",
                    "银川市",
                    "唐山市",
                    "承德市",
                    "齐齐哈尔市",
                    "天津市",
                    "松滋市",
                    "咸宁市",
                    "潜江市",
                    "潜江市, 直辖县级",
                    "永城市",
                    "平顶山市",
                    "三门峡市",
                    "开封市",
                    "十堰市",
                    "孝感市",
                    "天门市",
                    "天门市, 直辖县级",
                    "武穴市",
                    "荥阳市",
                    "新郑市",
                    "中牟县",
                    "郑州市",
                    "荆州市",
                    "楚雄市",
                    "保山市",
                    "曲靖市",
                    "宣威市",
                    "攀枝花市",
                    // 四川省德阳市旌阳区
                    "旌阳区",
                    "绵阳市",
                    "西充县",
                    "达州市",
                    "遂宁市",
                    "拉萨市",
                    "泸州市",
                    "西安市",
                    "沧州市",
                    "汕头市",
                    // 20210126 城市拦截
                    "宁波市",
                    "衢州市",
                    "湖州市",
                    "舟山市",
                    "嘉兴市",
                    "海宁市",
                    "杭州市",
                    "绍兴市",
                    "金华市",
                    "义乌市",
                    "淮南市",
                    "宣城市",
                    "马鞍山市",
                    "苏州市",
                    "泰州市",
                    "连云港市",
                    "徐州市",
                    "常州市",
                    "德州市",
                    "潍坊市",
                    "滨州市",
                    "烟台市",
                    "威海市",
                    "青岛市",
                    "河源市",
                    "潮州市",
                    "信宜市",
                    "肇庆市",
                    "江门市",
                    "开平市",
                    "云浮市",
                    "茂名市",
                    "汕尾市",
                    "化州市",
                    "陆丰市",
                    "龙川县",
                    "鹤山市",
                    "凤岗镇",
                    "阳江市",
                    "怀集县",
                    "广宁县",
                    "高州市",
                    "珠海市",
                    "吴川市",
                    "湛江市",
                    "韶关市",
                    "清远市",
                    "梅州市",
                    "五华县",
                    "兴宁市",
                    "英德市",
                    "连州市",
                    "平潭县",
                    "福清市",
                    "南宁市",
                    "桂林市",
                    "百色市",
                    "玉林市",
                    "梧州市",
                    "上饶市",
                    "景德镇市",
                    "新余市",
                    "九江市",
                    "宜春市",
                    "赣州市",
                    "福州市",
                    "泉州市",
                    "莆田市",
                    "宁德市",
                    "贵阳市",
                    "遵义市",
                    "安顺市",
                    "六盘水市",
                    "乌鲁木齐市",
                    "西宁市",
                    "庆阳市",
                    "太原市",
                    "呼和浩特市",
                    "廊坊市",
                    "保定市",
                    "沈阳市",
                    "丹东市",
                    "永州市",
                    "公安县",
                    "荆门市",
                    "浏阳市",
                    "怀化市",
                    "株洲市",
                    "醴陵市",
                    "岳阳市",
                    "益阳市",
                    "商丘市",
                    "焦作市",
                    "南阳市",
                    "洛阳市",
                    "安阳市",
                    "新乡市",
                    "濮阳市",
                    "周口市",
                    "信阳市",
                    "随州市",
                    "襄阳市",
                    "恩施土家族苗族自治州",
                    "来凤县",
                    "利川市",
                    "湘西土家族苗族自治州",
                    "宜昌市",
                    "宜都市",
                    "常德市",
                    "安陆市",
                    "应城市",
                    "仙桃市",
                    "仙桃市, 直辖县级",
                    "邵阳市",
                    "衡阳市",
                    "娄底市",
                    "大冶市",
                    "黄石市",
                    "浠水县",
                    "蕲春县",
                    "鄂州市",
                    "黄冈市",
                    "武汉市",
                    "张家界市",
                    "桑植县",
                    "慈利县",
                    "大理白族自治州",
                    "内江市",
                    "宜宾市",
                    "荣昌县",
                    "南充市",
                    "自贡市",
                    "广安市",
                    "长寿区",
                    "玉溪市",
                    "江津区",
					"榆林市",
					 "台山市",
					"廉江市",
					"新丰县",
					"连南瑶族自治县",
					"罗源县",
					"南安市",
					"晋江市",
					"石狮市",
					"仙游县",
					"方中县",
                    "澧县",
                    "宁乡市, 长沙市",
                    "四会市",
					"中方县",
					"延安市",
					"渭南市",
                    "南部县",
                    "南部县, 南充市",
					"邯郸市",
					"海宁市, 嘉兴市",
					"义乌市, 金华市",
					"信宜市, 茂名市",
					"开平市, 江门市",
					"化州市, 茂名市",
					"陆丰市, 汕尾市",
					"龙川县, 河源市",
					"鹤山市, 江门市",
					"凤岗镇, 东莞市",
					"怀集县, 肇庆市",
					"广宁县, 肇庆市",
					"高州市, 茂名市",
					"吴川市, 湛江市",
					"五华县, 梅州市",
					"兴宁市, 梅州市",
					"英德市, 清远市",
					"连州市, 清远市",
					"平潭县, 福州市",
					"福清市, 福州市",
					"公安县, 荆州市",
					"浏阳市, 长沙市",
					"醴陵市, 株洲市",
					"来凤县, 恩施土家族苗族自治州",
					"利川市, 恩施土家族苗族自治州",
					"宜都市, 宜昌市",
					"安陆市, 孝感市",
					"应城市, 孝感市",
					"大冶市, 黄石市",
					"浠水县, 黄冈市",
					"蕲春县, 黄冈市",
					"桑植县, 张家界市",
					"慈利县, 张家界市",
					"长寿区, 重庆市",
					"江津区, 重庆市",
					"滨海新区, 天津市",
					"松滋市, 荆州市",
					"永城市, 商丘市",
					"武穴市, 黄冈市",
					"楚雄市, 楚雄彝族自治州",
					"涪陵区, 重庆市",
					"永川区, 重庆市",
					"西充县, 南充市",
					"石家庄市",
					"澳门半岛",
					/*20210223拦截*/
					"聊城市",
					"宁乡市",
					/*20210311拦截*/
                    "北京市",
                    /*20210322拦截*/
					"长沙市",
                    ];
                if(cityInterceptList.includes(locationCity.name) && locationCity.name){
                    location.href = 'https://m.xfxb.net/mall';
                    return
                }
                let self = this;
                const { goodsBean:{goodsChannelId,type}, counter,currSkuBean:{id} } = this;
                self.submitLoading = false;
                let proInfo=[];
                proInfo.push({
                    goodsChannelId: goodsChannelId,
                    goodsNum: counter,
                    skuId: type == 1 ? id : undefined
                });
                this.$store.dispatch('addCart', proInfo).then(function () {
                    self.show = true;
                    setTimeout(function () {
                        self.show = false;
                    }, 500);
                },function(err){
                    Toast(err || '系统错误')
                }).then(function(){
                    self.submitLoading = true;
                })
            },
            checkOut() {
                // 立即购买，跳转微商城
                let locationCity = JSON.parse(localStorage.getItem('locationCity'));
                // 下单结算，跳转微商城
				let cityInterceptList = [
                    "上海市",
                    "衡水市",
                    "抚顺市",
                    "南通市",
                    "海门市",
                    "盐城市",
                    "漳州市",
                    "漳浦县",
                    "南昌市",
                    "武汉市",
                    "郴州市",
                    "永兴县",
                    "佛山市",
                    "惠州市",
                    "昆明市",
                    "安宁市",
                    "广州市",
                    "深圳市",
                    "东莞市",
                    // 重庆下面的区
                    "重庆市",
                    "梁平县",
                    "两江新区",
                    "万州区",
                    "渝中区",
                    "大渡口区",
                    "江北区",
                    "沙坪坝区",
                    "九龙坡区",
                    "南岸区",
                    "北碚区",
                    "大足区",
                    "渝北区",
                    "巴南区",
                    "黔江区",
                    "合川区",
                    "南川区",
                    "璧山区",
                    "铜梁区",
                    "潼南县",
                    "城口县",
                    "丰都县",
                    "武隆县",
                    "忠县",
                    "开县",
                    "云阳县",
                    "奉节县",
                    "巫山县",
                    "巫溪县",
                    "石柱土家族自治县",
                    "秀山土家族苗族自治县",
                    "酉阳土家族苗族自治县",
                    "彭水苗族土家族自治县",
                    "开州区",
                    "垫江县",
                    "荣昌县",
                    "綦江区",
                    "涪陵区",
                    "永川区",
                    // 成都眉山地区20210113拦截
                    "眉山市",
                    "成都市",
                    "新津县",
                    // 20110118拦截
                    "温州市",
                    "合肥市",
                    "蚌埠市",
                    "芜湖市",
                    "无锡市",
                    "淮安市",
                    "泰安市",
                    "新泰市",
                    "济南市",
                    "南京市",
                    "中山市",
                    "揭阳市",
                    "揭西县",
                    "厦门市",
                    "柳州市",
                    "北海市",
                    "海口市",
                    "三亚市",
                    "东方市",
                    "东方市, 直辖县级",
                    "吉安市",
                    "萍乡市",
                    "抚州市",
                    "铜仁市",
                    "黔西南布依族苗族自治州",
                    "毕节市",
                    "兰州市",
                    "哈尔滨市",
                    "大连市",
                    "长春市",
                    "张家口市",
                    "滨海新区",
                    "秦皇岛市",
                    "银川市",
                    "唐山市",
                    "承德市",
                    "齐齐哈尔市",
                    "天津市",
                    "松滋市",
                    "咸宁市",
                    "潜江市",
                    "潜江市, 直辖县级",
                    "永城市",
                    "平顶山市",
                    "三门峡市",
                    "开封市",
                    "十堰市",
                    "孝感市",
                    "天门市",
                    "天门市, 直辖县级",
                    "武穴市",
                    "荥阳市",
                    "新郑市",
                    "中牟县",
                    "郑州市",
                    "荆州市",
                    "楚雄市",
                    "保山市",
                    "曲靖市",
                    "宣威市",
                    "攀枝花市",
                    // 四川省德阳市旌阳区
                    "旌阳区",
                    "绵阳市",
                    "西充县",
                    "达州市",
                    "遂宁市",
                    "拉萨市",
                    "泸州市",
                    "西安市",
                    "沧州市",
                    "汕头市",
                    // 20210126 城市拦截
                    "宁波市",
                    "衢州市",
                    "湖州市",
                    "舟山市",
                    "嘉兴市",
                    "海宁市",
                    "杭州市",
                    "绍兴市",
                    "金华市",
                    "义乌市",
                    "淮南市",
                    "宣城市",
                    "马鞍山市",
                    "苏州市",
                    "泰州市",
                    "连云港市",
                    "徐州市",
                    "常州市",
                    "德州市",
                    "潍坊市",
                    "滨州市",
                    "烟台市",
                    "威海市",
                    "青岛市",
                    "河源市",
                    "潮州市",
                    "信宜市",
                    "肇庆市",
                    "江门市",
                    "开平市",
                    "云浮市",
                    "茂名市",
                    "汕尾市",
                    "化州市",
                    "陆丰市",
                    "龙川县",
                    "鹤山市",
                    "凤岗镇",
                    "阳江市",
                    "怀集县",
                    "广宁县",
                    "高州市",
                    "珠海市",
                    "吴川市",
                    "湛江市",
                    "韶关市",
                    "清远市",
                    "梅州市",
                    "五华县",
                    "兴宁市",
                    "英德市",
                    "连州市",
                    "平潭县",
                    "福清市",
                    "南宁市",
                    "桂林市",
                    "百色市",
                    "玉林市",
                    "梧州市",
                    "上饶市",
                    "景德镇市",
                    "新余市",
                    "九江市",
                    "宜春市",
                    "赣州市",
                    "福州市",
                    "泉州市",
                    "莆田市",
                    "宁德市",
                    "贵阳市",
                    "遵义市",
                    "安顺市",
                    "六盘水市",
                    "乌鲁木齐市",
                    "西宁市",
                    "庆阳市",
                    "太原市",
                    "呼和浩特市",
                    "廊坊市",
                    "保定市",
                    "沈阳市",
                    "丹东市",
                    "永州市",
                    "公安县",
                    "荆门市",
                    "浏阳市",
                    "怀化市",
                    "株洲市",
                    "醴陵市",
                    "岳阳市",
                    "益阳市",
                    "商丘市",
                    "焦作市",
                    "南阳市",
                    "洛阳市",
                    "安阳市",
                    "新乡市",
                    "濮阳市",
                    "周口市",
                    "信阳市",
                    "随州市",
                    "襄阳市",
                    "恩施土家族苗族自治州",
                    "来凤县",
                    "利川市",
                    "湘西土家族苗族自治州",
                    "宜昌市",
                    "宜都市",
                    "常德市",
                    "安陆市",
                    "应城市",
                    "仙桃市",
                    "仙桃市, 直辖县级",
                    "邵阳市",
                    "衡阳市",
                    "娄底市",
                    "大冶市",
                    "黄石市",
                    "浠水县",
                    "蕲春县",
                    "鄂州市",
                    "黄冈市",
                    "武汉市",
                    "张家界市",
                    "桑植县",
                    "慈利县",
                    "大理白族自治州",
                    "内江市",
                    "宜宾市",
                    "荣昌县",
                    "南充市",
                    "自贡市",
                    "广安市",
                    "长寿区",
                    "玉溪市",
                    "江津区",
					"榆林市",
					 "台山市",
					"廉江市",
					"新丰县",
					"连南瑶族自治县",
					"罗源县",
					"南安市",
					"晋江市",
					"石狮市",
					"仙游县",
					"方中县",
                    "澧县",
                    "宁乡市, 长沙市",
                    "四会市",
					"中方县",
					"延安市",
					"渭南市",
                    "南部县",
                    "南部县, 南充市",
					"邯郸市",
					"海宁市, 嘉兴市",
					"义乌市, 金华市",
					"信宜市, 茂名市",
					"开平市, 江门市",
					"化州市, 茂名市",
					"陆丰市, 汕尾市",
					"龙川县, 河源市",
					"鹤山市, 江门市",
					"凤岗镇, 东莞市",
					"怀集县, 肇庆市",
					"广宁县, 肇庆市",
					"高州市, 茂名市",
					"吴川市, 湛江市",
					"五华县, 梅州市",
					"兴宁市, 梅州市",
					"英德市, 清远市",
					"连州市, 清远市",
					"平潭县, 福州市",
					"福清市, 福州市",
					"公安县, 荆州市",
					"浏阳市, 长沙市",
					"醴陵市, 株洲市",
					"来凤县, 恩施土家族苗族自治州",
					"利川市, 恩施土家族苗族自治州",
					"宜都市, 宜昌市",
					"安陆市, 孝感市",
					"应城市, 孝感市",
					"大冶市, 黄石市",
					"浠水县, 黄冈市",
					"蕲春县, 黄冈市",
					"桑植县, 张家界市",
					"慈利县, 张家界市",
					"长寿区, 重庆市",
					"江津区, 重庆市",
					"滨海新区, 天津市",
					"松滋市, 荆州市",
					"永城市, 商丘市",
					"武穴市, 黄冈市",
					"楚雄市, 楚雄彝族自治州",
					"涪陵区, 重庆市",
					"永川区, 重庆市",
					"西充县, 南充市",
					"石家庄市",
					"澳门半岛",
					/*20210223拦截*/
					"聊城市",
					"宁乡市",
					/*20210311拦截*/
                    "北京市",
                    /*20210322拦截*/
					"长沙市",
                    ];
                if(cityInterceptList.includes(locationCity.name) && locationCity.name){
                    location.href = 'https://m.xfxb.net/mall';
                    return
                }
                let self = this;
                self.submitLoading = false;
                const { goodsBean:{goodsChannelId,type}, counter,currSkuBean:{id} } = this;
                let proInfo=[];
                proInfo.push({
                    goodsChannelId: goodsChannelId,
                    goodsNum: counter,
                    skuId: type == 1 ? id : undefined
                });
                console.log(proInfo);
                this.$store.dispatch('addCart', proInfo).then(function (res) {
                    self.$router.push({path: '/ShoppingCart'});
                },function(err){
                    Toast(err || '系统错误')
                }).then(function(){
                    self.submitLoading = true;
                })
            }
        },
        destroyed() {
            this.$store.dispatch('proInit');
        }

    }
</script>

<style lang="scss">
    @import '../../../assets/css/mixin';

    .page-lazyload-image[lazy=loading] {
        width: 100% !important;
        height: 300px;
        background-color: rgba(0, 0, 0, .3);
    }

    .proDetails-panel {
        padding-top: pxToRem(100px);
        background-color: #eee;
    }

    .bg-sec {
        background-color: #fff;
    }

    .page-infinite-listitem {
        height: 150px;
        line-height: 150px;
    }

    .pro-img-swiper {
        width: 100%;
        height: pxToRem(750px);
        img {
            max-width: 100%;
            min-height: 100%;
        }
        .mint-swipe-indicator {
            background-color: rgba(255, 255, 255, 1);
            opacity: 0.5;
            transform: scale(.8);
            &.is-active {
                background-color: rgba(255, 255, 255, 1);
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    .pro-titles {
        padding: pxToRem(65px) 0;
        text-align: center;
        
        h1 {
            font-size: pxToRem(28px);
            font-weight: normal;
            line-height: 1.2em;
        }
        .text-red, .text-grey {
            margin-top: pxToRem(20px);
            line-height: 1;
        }
        .text-grey {
            font-size: pxToRem(20px);
        }

    }

    .pro-spec {
        padding: pxToRem(60px) pxToRem(10px) 0 pxToRem(10px);
        border-top: 1px solid #ccc;    
        .spec-list {
            margin: pxToRem(20px) 0;
            font-size: 0;

            .item-spec {
                padding: pxToRem(15px) pxToRem(35px);
                margin-bottom: pxToRem(20px);
                display: inline-block;
                // min-width: pxToRem(140px);
                // height: pxToRem(60px);
                // line-height: pxToRem(60px);
                line-height: 1;
                text-align: center;
                font-size: pxToRem(26px);
                border: 1px solid #666;
                &:not(:last-of-type) {
                    margin-right: pxToRem(36px);
                }
                &.active {
                    background-color: #D8331D;
                    color: #fff;
                    border-color: #D8331D;
                }
            }
        }

        .spec-details {
            // margin-top: pxToRem(40px);
            padding: pxToRem(20px) pxToRem(16px) pxToRem(60px) pxToRem(16px);
            color: #666666;
            border-top: 1px solid #EEEEEE;

            .spec-details-list {
                font-size: 0;
                li {
                    padding: pxToRem(10px);
                    display: inline-block;
                    // line-height: .6rem;
                    font-size: pxToRem(20px);
                    vertical-align: top;
                    width: 100%;
                    display: inline-flex;

                    span:first-of-type {
                    }
                    span:last-of-type {
                        width: 1px;
                        flex: 1;

                    }
                }
            }
        }
    }

    .counter-operate {
        padding: pxToRem(40px) pxToRem(10px);
        display: flex;
        justify-content: space-between;
        line-height: pxToRem(40px);
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;

        .text-counter {
            margin: 0 pxToRem(40px);
        }

    }

    .pro-help {
        padding: pxToRem(40px) pxToRem(10px);
        display: flex;
        justify-content: space-between;

        .item-help {
            border-bottom: 1px solid #191919;
        }
    }

    .pro-details {
        margin-top: pxToRem(60px);
        padding-top: pxToRem(80px);
        text-align: center;

        .title {
            font-size: pxToRem(24px);
            font-weight: normal;
        }

        .pro-details-info {
            margin-top: pxToRem(58px);
            padding-bottom: pxToRem(80px);

            img {
                width: 100%;
                max-width: 100%;
            }
        }
    }

    .pro-footer {
        position: fixed;
        display: flex;
        width: 100%;
        bottom: 0;
        left: 0;
        text-align: center;
        .i-cart, .i-buynow {
            flex: 1;
            line-height: pxToRem(110px);
            color: #fff;
            font-size: pxToRem(32px);
        }
        .i-cart {
            background-color: #D4B675;
        }
        .i-buynow {
            background-color: #D8331D;
        }
        .i-disabled{
            background-color: #D3D3D3;
        }
        .i-disabled-buynow{
            background-color: #808080;
        }
    }

    .promise-popup {
        width: 100%;
        text-align: center;
        background-color: #EEEEEE;

        .promise-sec {
            padding: pxToRem(40px) 0;
            .promise-line {
                padding: pxToRem(16px) 0;
                line-height: 1;
            }

            .i-b {
                font-weight: bold;
            }
        }

        .title {
            padding: pxToRem(16px) 0;
            font-size: pxToRem(28px);
        }

        .promise-btn {
            padding: pxToRem(36px) 0;
            height: pxToRem(100px);
            display: inline-block;
            width: 100%;
            background-color: #fff;

        }

    }

    .detailsHeader {
        &.fixed {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 99;
        }
    }

    .up-count {
        position: absolute;
        top: 0;
        left: 25%;
        margin-left: pxToRem(-10px);
        color: #D8331D;
        font-weight: bold;
        font-size: pxToRem(26px);
    }

    .fade-enter-active {
        top: - pxToRem(80px);
        transform: scale(1.5);
        opacity: 1;
        transition: all .5s ease;
    }

    .fade-enter /* .fade-leave-active in below version 2.1.8 */
    {
        top: 0;
        transform: scale(1);
        opacity: 0;
    }

    .fade-leave-active {
        top: - pxToRem(50px);
        opacity: 0;
    }

    .fade-leave-to {
        top: - pxToRem(50px);
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// productDetail.vue?826a2f60